// extracted by mini-css-extract-plugin
export default {"contentBox":"index_contentBox_VLoKR"};